import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon } from '@heroicons/react/24/outline';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-custom py-12">
        <Link to="/" className="inline-flex items-center text-medical-600 hover:text-medical-700 mb-8">
          <HomeIcon className="w-5 h-5 mr-2" />
          Voltar para Home
        </Link>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-6 text-gradient">Privacy Policy</h1>
          <p className="text-gray-600 mb-8">Última atualização: 12 de outubro de 2025</p>

          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">1. Introdução</h2>
            <p className="text-gray-700 leading-relaxed">
              A AudFast está comprometida com a proteção da privacidade e segurança dos dados de seus usuários.
              Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações pessoais.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">2. Dados Coletados</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Coletamos informações necessárias para fornecer nossos serviços de audiometria ocupacional:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
              <li>Informações de identificação (nome, e-mail, registro profissional)</li>
              <li>Dados de pacientes (anônimos quando possível)</li>
              <li>Resultados de exames audiométricos</li>
              <li>Informações de empresas e ambientes de trabalho</li>
              <li>Dados de uso da plataforma</li>
            </ul>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">3. Uso dos Dados</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Utilizamos seus dados para:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
              <li>Fornecer análises audiométricas e laudos técnicos</li>
              <li>Melhorar nossos algoritmos de inteligência artificial</li>
              <li>Garantir conformidade legal (NR-7, Portaria 19/98)</li>
              <li>Comunicar atualizações e suporte técnico</li>
            </ul>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">4. Segurança dos Dados</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Implementamos medidas de segurança robustas incluindo:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
              <li>Criptografia de dados em trânsito e em repouso</li>
              <li>Controle de acesso baseado em funções (RBAC)</li>
              <li>Backups regulares e redundância de dados</li>
              <li>Conformidade com LGPD e boas práticas de segurança</li>
            </ul>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">5. Compartilhamento de Dados</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Não compartilhamos seus dados pessoais com terceiros, exceto quando:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
              <li>Requerido por lei ou ordem judicial</li>
              <li>Necessário para prestadores de serviços essenciais (ex: hospedagem)</li>
              <li>Com seu consentimento explícito</li>
            </ul>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">6. Seus Direitos</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Você tem direito a:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
              <li>Acessar seus dados pessoais</li>
              <li>Corrigir informações incorretas</li>
              <li>Solicitar exclusão de dados (<Link to="/data-deletion" className="text-medical-600 hover:underline">Data Deletion</Link>)</li>
              <li>Exportar seus dados em formato estruturado</li>
              <li>Revogar consentimento a qualquer momento</li>
            </ul>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">7. Contato</h2>
            <p className="text-gray-600 leading-relaxed">
              Para questões sobre privacidade, entre em contato:
              <br />
              E-mail: <a href="mailto:privacy@audfast.com" className="text-medical-600 hover:underline">privacy@audfast.com</a>
              <br />
              <Link to="/contact" className="text-medical-600 hover:underline">Formulário de Contato</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
